import React from "react";
import isEmpty from 'lodash/isEmpty';

import { Tooltip } from "@material-ui/core";
import { VIEWS_MEDIBUDDY_URL } from "../constant"

const StatusFLow = {
  Passed: {
    text: "Passed",
    textColor: "text-[#004FB6]",
    bgColor: "bg-[#E2F0FF]",
    borderColor: "border-[#9ACBFF]",
    icon : 'https://views.medibuddy.in/providerUi/assets/warning.svg'
  },
  Draft: {
    text: "Draft",
    textColor: "text-[#47566A]",
    bgColor: "bg-[#EBEEF1]",
    borderColor: "border-[#BFC8D2]",
  },
  InProgress: {
    text: "In Progress",
    textColor: "text-[#9F5A07]",
    bgColor: "bg-[#FFF7CE]",
    borderColor: "border-[#FCDE64]",
    icon : 'https://views.medibuddy.in/providerUi/assets/warning.svg'
  },
  Failed: {
    text: "Failed",
    textColor: "text-[#AE0006]",
    bgColor: "bg-[#FEE9EA]",
    borderColor: "border-[#FCB5B8]",
    icon : 'https://views.medibuddy.in/providerUi/assets/failed.svg'
  },
  Error: {
    text: "Error",
    textColor: "text-[#AE0006]",
    bgColor: "bg-[#FEE9EA]",
    borderColor: "border-[#FCB5B8]",
    icon : 'https://views.medibuddy.in/providerUi/assets/failed.svg'
  }
};

const errorStatuses = ['error', 'warning', 'failed'];

const QCStatusButton = ({ qcStatus, iconType }) => {
  return (
    <button
      className={`flex px-2 py-1 border border-solid rounded-full font-normal text-xs justify-center gap-1 ${StatusFLow[qcStatus]?.textColor} ${StatusFLow[qcStatus]?.bgColor} ${StatusFLow[qcStatus]?.borderColor}`}
    >
      <p>{StatusFLow[qcStatus]?.text}</p> {iconType?  <p><img src={iconType} alt="" height={15} width={15} className="" /></p>: null}
    </button>
  );
}
export const QCStatus = ({ qcStatus ='Passed' ,qcRemarks=''}) => {

 const statusCount = Object.values(qcRemarks).reduce((acc, { status }) => {
  if (errorStatuses.includes(status.toLowerCase())) {
    acc[status] = (acc[status] || 0) + 1;
}  return acc;
}, {});


  return (
    <div>
      {!isEmpty(statusCount) ? (

        <Tooltip title={
          <React.Fragment>
            <p className="p-1">
              {Object.entries(statusCount).map(([key, value]) => (
                <p key={key} className="text-xs font-normal">&#x2022; {`${value} ${key}`}</p>
              ))}
            </p>
          </React.Fragment>
        }>
          <div className="flex">
            <QCStatusButton qcStatus={qcStatus} iconType={StatusFLow[qcStatus]?.icon} />
          </div>
        </Tooltip>

      ) : (<QCStatusButton qcStatus={qcStatus} />
      )}

    </div>
  );
};